import { createConsola, LogLevels } from "consola/browser";

export const logger = createConsola({
  level: import.meta.env.DEV ? LogLevels.trace : LogLevels.warn,
});
